var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Editor',{attrs:{"init":_vm.editorOptions,"disabled":_vm.disabled,"outputFormat":_vm.outputFormat},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }